import React from 'react'

const Svg = () => (
  <svg
    className="site-logo__svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 177.22 24.43"
  >
    <g className="trademark">
      <path
        className="line cls-2"
        d="M.8,5.72a.79.79,0,0,0-.8.8V19.83a.79.79,0,0,0,.8.79.79.79,0,0,0,.8-.79V6.52a.79.79,0,0,0-.8-.8"
      />
      <path
        className="line cls-2"
        d="M4.74,9.52a.79.79,0,0,0-.8.8V23.63a.8.8,0,1,0,1.6,0V10.32a.79.79,0,0,0-.8-.8"
      />
      <path
        className="line cls-2"
        d="M8.68,6.3a.79.79,0,0,0-.8.8V18.71a.8.8,0,0,0,1.6,0V7.1a.79.79,0,0,0-.8-.8"
      />
      <path
        className="line cls-2"
        d="M12.62,3.69a.8.8,0,0,0-.81.8V22.84a.8.8,0,0,0,.81.8.79.79,0,0,0,.8-.8V4.49a.79.79,0,0,0-.8-.8"
      />
      <path
        className="line cls-2"
        d="M16.55,7.14a.79.79,0,0,0-.8.8V20.23a.79.79,0,0,0,.8.8.8.8,0,0,0,.81-.8V7.94a.8.8,0,0,0-.81-.8"
      />
      <path
        className="line cls-2"
        d="M20.49,12.31a.79.79,0,0,0-.8.79v5.59a.8.8,0,0,0,1.6,0V13.1a.79.79,0,0,0-.8-.79"
      />
    </g>
    <g className="letters">
      <path
        className="letter cls-2"
        d="M38.53,7a1.19,1.19,0,0,0-1.17.8L33.15,18,28.93,7.76A1.19,1.19,0,0,0,27.76,7a1.23,1.23,0,0,0-1.25,1.24,1.43,1.43,0,0,0,.09.47L32,21.3h0a1.27,1.27,0,0,0,2.33,0L39.67,8.7l0,0a1.31,1.31,0,0,0,.09-.46A1.23,1.23,0,0,0,38.53,7"
      />
      <path
        className="letter cls-2"
        d="M47.44,19.94c-2.91,0-4.33-1.78-4.33-5.46s1.42-5.43,4.33-5.43,4.32,1.78,4.32,5.43-1.42,5.46-4.32,5.46m0-13.18c-4.42,0-6.86,2.74-6.86,7.72s2.44,7.75,6.86,7.75,6.85-2.75,6.85-7.75-2.44-7.72-6.85-7.72"
      />
      <path
        className="letter cls-2"
        d="M57.82,7a1.23,1.23,0,0,0-1.25,1.24V20.84a1.25,1.25,0,0,0,2.5,0V8.19A1.23,1.23,0,0,0,57.82,7"
      />
      <path
        className="letter cls-2"
        d="M57.82,0a1.31,1.31,0,0,0-1.44,1.48V2a1.44,1.44,0,0,0,2.88,0V1.51A1.31,1.31,0,0,0,57.82,0"
      />
      <path
        className="letter cls-2"
        d="M72.33,18.38a1.27,1.27,0,0,0-.75.27,5.5,5.5,0,0,1-3.5,1.29c-2.82,0-4.19-1.78-4.19-5.46s1.37-5.43,4.19-5.43a3.83,3.83,0,0,1,3.22,1.38,1.18,1.18,0,0,0,.94.46,1.13,1.13,0,0,0,1.15-1.15A1.16,1.16,0,0,0,73.13,9a6.2,6.2,0,0,0-5-2.25c-4.4,0-6.72,2.67-6.72,7.72s2.32,7.75,6.72,7.75A7.46,7.46,0,0,0,73,20.48a1.18,1.18,0,0,0,.49-.95,1.16,1.16,0,0,0-1.16-1.15"
      />
      <path
        className="letter cls-2"
        d="M81.52,9.05c2.44,0,3.71,1.36,3.78,4h-8c.26-2.61,1.74-4,4.18-4m4.66,9.33a1.15,1.15,0,0,0-.72.24,5.57,5.57,0,0,1-3.63,1.29c-2.7,0-4.41-1.75-4.5-4.6h8.94c1.5,0,1.5-1.34,1.5-2.23,0-1.06-.3-6.32-6.25-6.32-4.28,0-6.73,2.82-6.73,7.72,0,5.07,2.44,7.75,7,7.75a7.17,7.17,0,0,0,5.08-1.82,1.13,1.13,0,0,0,.42-.88,1.16,1.16,0,0,0-1.15-1.15"
      />
      <path
        className="letter cls-2"
        d="M106.76,9.4a4.69,4.69,0,0,1,4.51-2.57,1,1,0,1,1,0,2c-3,0-4.51,2.06-4.51,5V21a1,1,0,0,1-2.08,0V8a1,1,0,0,1,2.08,0Z"
      />
      <path
        className="letter cls-2"
        d="M119.54,6.77a6.13,6.13,0,0,1,5,2.21.93.93,0,0,1,.23.61.91.91,0,0,1-.94.93,1,1,0,0,1-.78-.38,4.15,4.15,0,0,0-3.5-1.51c-3,0-4.57,1.89-4.57,5.84s1.58,5.88,4.57,5.88A6,6,0,0,0,123.3,19a1,1,0,0,1,.62-.23.94.94,0,0,1,.94.93,1,1,0,0,1-.42.81,7.5,7.5,0,0,1-4.9,1.73c-4.18,0-6.68-2.47-6.68-7.74s2.5-7.7,6.68-7.7"
      />
      <path
        className="letter cls-2"
        d="M139.86,12.45V21a1,1,0,0,1-2.07,0V12.87c0-2.54-.75-4.27-3.89-4.27s-4.32,1.92-4.32,4.49V21a1,1,0,0,1-2.07,0l-.05-20a1,1,0,0,1,2.07,0l.05,8a4.75,4.75,0,0,1,4.32-2.25c5,0,6,3,6,5.68"
      />
      <path
        className="letter cls-2"
        d="M143.15,7a1,1,0,0,0-1,1V21a1,1,0,0,0,2.08,0V8a1,1,0,0,0-1-1"
      />
      <path
        className="letter cls-2"
        d="M143.15,0c-.78,0-1.23.35-1.23,1.28v.47a1.23,1.23,0,0,0,2.46,0V1.28c0-.93-.45-1.28-1.23-1.28"
      />
      <path
        className="letter cls-2"
        d="M152.13,21.41l-5.51-13a1.07,1.07,0,0,1-.1-.45,1,1,0,0,1,1-1,1,1,0,0,1,1,.68l4.57,11.07,4.57-11.07a1,1,0,0,1,1-.68,1,1,0,0,1,1,1,1.25,1.25,0,0,1-.1.45l-5.51,13a1.07,1.07,0,0,1-1,.64,1,1,0,0,1-1-.64"
      />
      <path
        className="letter cls-2"
        d="M167.37,8.63c-2.82,0-4.38,1.8-4.57,4.66h8.72c0-2.32-.81-4.66-4.15-4.66m0-1.86c5.19,0,6.19,4.08,6.19,6.26,0,.93,0,2.05-1.29,2.05H162.8c0,3.18,1.85,5.24,4.9,5.24a6,6,0,0,0,3.89-1.39.94.94,0,0,1,1.16,1.48,7.24,7.24,0,0,1-5.05,1.8c-4.32,0-7-2.34-7-7.74,0-4.94,2.47-7.7,6.68-7.7"
      />
      <path
        className="letter cls-2"
        d="M100.3,15.78h0v.86a1.46,1.46,0,0,1,0,.29c-.21,2.46-2.32,3.7-4.52,3.7-2.59,0-3.79-1.06-3.79-2.73a2.38,2.38,0,0,1,1-2h0a2.13,2.13,0,0,1,.37-.22l.09-.05.07,0a3.29,3.29,0,0,1,.44-.16c2.12-.7,6.12-.88,6.37-1.34,0,.44,0,1.72,0,1.72m-3.76-9a6,6,0,0,0-5.32,2.54,1,1,0,0,0-.16.54.93.93,0,0,0,.93.94,1,1,0,0,0,.83-.45,4.43,4.43,0,0,1,3.72-1.64A3.44,3.44,0,0,1,100.17,11a1.21,1.21,0,0,1-.25,1.21,2.7,2.7,0,0,1-1,.49,9.76,9.76,0,0,1-1.63.29c-.62.07-1.27.18-2,.31a19.47,19.47,0,0,0-1.9.45,5.07,5.07,0,0,0-1.64.78,3.77,3.77,0,0,0-1.17,1.33A4.54,4.54,0,0,0,90.16,18a4.34,4.34,0,0,0,.4,2,3.54,3.54,0,0,0,1.07,1.31,4.49,4.49,0,0,0,1.61.73,8.16,8.16,0,0,0,4.91-.31,5.84,5.84,0,0,0,2.18-1.55V21a1,1,0,0,0,2,0V12.2c0-3.27-2-5.46-5.78-5.46"
      />
      <path
        className="letter cls-2"
        d="M176,6.35l-.41-.7V6.73a.23.23,0,1,1-.45,0V4.8a.22.22,0,0,1,.22-.23.25.25,0,0,1,.22.14l.61,1.1.61-1.1a.25.25,0,0,1,.22-.14.22.22,0,0,1,.22.23V6.73a.23.23,0,1,1-.45,0V5.65l-.41.7a.21.21,0,0,1-.19.1.2.2,0,0,1-.19-.1Zm-1.44-1.74a.22.22,0,1,1,0,.43H174V6.72a.24.24,0,0,1-.24.24.24.24,0,0,1-.24-.24V5H173a.2.2,0,0,1-.21-.21.21.21,0,0,1,.21-.22Z"
      />
    </g>
  </svg>
)

export default Svg
